import React from 'react';
import { Background, LogoContainer } from './style';
import { Icon } from '../../Components/Icons/Icons';

export const AuthenticationWrapper = ({ children }) => (
    <Background>
        <LogoContainer>
            <Icon.Box size={'36x20'}>
                <Icon.Logo />
            </Icon.Box>
        </LogoContainer>
        {children}
    </Background>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/AuthenticationWrapper.js